import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../constants/msgConstants'
import notaFiscalManager from '../../services/api/notaFiscal/notaFiscalManager'
import { RegraNotaFiscal } from '../../types/notaFiscalApiTypes'
import { useLoading } from '../../hooks/useLoading'

export function regraNotaFiscalIO() {
  const { parceiroId, regraId } = useParams<{ parceiroId: string; regraId: string }>()
  const [regraNotaFiscalEditar, setRegraNotaFiscalEditar] = useState<RegraNotaFiscal>()
  const { showLoading, hideLoading } = useLoading()

  useEffect(() => {
    if (!regraId) {
      hideLoading()
      return
    }

    showLoading()
    notaFiscalManager
      .buscarRegra(parceiroId, regraId)
      .then((response: RegraNotaFiscal) => {
        setRegraNotaFiscalEditar(response)
      })
      .catch(() => toast.error(msgConstants.USO_GENERICO.erroBusca))
      .finally(() => hideLoading())
  }, [parceiroId, regraId, showLoading, hideLoading])

  return {
    regraNotaFiscalEditar,
    regraId
  }
}

export type RegraNotaFiscalIO = ReturnType<typeof regraNotaFiscalIO>
